<template>
	<div>
		<FiltersListSection
			:clip-filters="playerFilters"
			:value="value"
			:title="title"
			@input="handleFiltersChange"
		>
			<template #subheader>
				<div class="subheader">
					<Checkbox
						:id="`all-players-ck`"
						:value="isAllSelected"
						:label="transUcfirst('commons.select_all')"
						:disabled="!canSelectAll"
						@input="handleSelectAll"
					/>
				</div>
			</template>
		</FiltersListSection>
	</div>
</template>

<script>
import FiltersListSection from './FiltersListSection';
import Checkbox from '../checkbox/Checkbox';
import { FILTER_GROUP_PLAYER } from '../../store/modules/clip-filters';

export default {
	name:       'AthleteFiltersSection',
	components: { Checkbox, FiltersListSection },
	props:      {
	  clipFilters: {
	    type:     Array,
			required: true,
		},
		title: {
	    	type:     String,
			required: true,
		},
		value: {
	    	type: Array,
		},
	},
	computed: {
		playerFilters() {
			return this.clipFilters
				.filter(
					(clipFilter) =>
						clipFilter.type === FILTER_GROUP_PLAYER
				)
				.sort((a, b) => {
					if (a.count === 0 && b.count === 0) {
						return 0;
					}

					if (b.count === 0) {
						return -1;
					}

					if (a.count === 0) {
						return 1;
					}

					return a.count > b.count ? -1 : 1;
				});
		},
		isAllSelected() {
	  		return !!(this.value.length && this.value.length === this.clipFilters.length);
		},
		eligiblePlayerFilters() {
			return this.playerFilters.filter(clipFilter => clipFilter.count > 0);
		},
		canSelectAll() {
			return this.eligiblePlayerFilters.length > 0;
		},
	},
	methods: {
		handleFiltersChange(selectedFilters) {
			this.$emit('input', selectedFilters);
		},
		handleSelectAll(val) {
			if (val) {
				this.handleFiltersChange([...this.eligiblePlayerFilters]);
			} else {
				this.handleFiltersChange([]);
			}
		},
	},
};
</script>

<style lang="scss" scoped>

.subheader {
	margin-bottom: 16px;
}
</style>
